import * as React from 'react';
import { connect } from 'react-redux';

import { Container } from '../../components/Container';

import { IApplicationState } from '../../types/redux';

import { OffersBodyContainer } from './OffersBodyContainer';
import { OffersFooterContainer } from './OffersFooterContainer';
import { OffersHeaderContainer } from './OffersHeaderContainer';
import { SimilarNewbuildings } from './SimilarNewbuildings';
import { INewbuilding, INewbuildingPromoSnippet } from '../../types/newbuilding';
import { SearchPreloader } from '../../components/SearchPreloader';
import { PromoSnippetContainer } from '../PromoSnippetContainer';
import {
  getIsNewbuildingPromoSnippetEnabled,
  getNewbuildingPromoSnippet,
} from '../../selectors/newbuildingPromoSnippet';
import { ISeo } from '../../types/offersData';

interface IOffersStoreProps {
  newbuildings: INewbuilding[];
  newbuildingPromoSnippet?: INewbuildingPromoSnippet | null;
  isPreloaderVisible: boolean;
  isNewbuildingPromoSnippetEnabled: boolean;
  isNewbuildingPromoSnippetDisplayed: boolean;
  children?: React.ReactNode;
  seo: ISeo | null;
}

type TOffersProps = IOffersStoreProps;

export const Offers: React.FunctionComponent<TOffersProps> = props => {
  const {
    newbuildings = [],
    isPreloaderVisible,
    children,
    newbuildingPromoSnippet,
    isNewbuildingPromoSnippetEnabled,
    isNewbuildingPromoSnippetDisplayed,
    seo,
  } = props;

  const isSnippetDisplayed = isNewbuildingPromoSnippetEnabled && isNewbuildingPromoSnippetDisplayed;

  return (
    <>
      {!!newbuildings.length && (
        <Container>
          <OffersHeaderContainer isPromoSnippetEnabled={isNewbuildingPromoSnippetEnabled} />
          {newbuildingPromoSnippet && isSnippetDisplayed && (
            <PromoSnippetContainer
              extensionFields={newbuildingPromoSnippet.extensionFields}
              newbuilding={newbuildingPromoSnippet.newbuilding}
            />
          )}
          <OffersBodyContainer
            newbuildings={newbuildings}
            isPromoNewbuildingDisplayed={isSnippetDisplayed}
            promoNewbuilding={newbuildingPromoSnippet?.newbuilding}
            aggregateRating={seo?.aggregateRating}
            reviewsCount={seo?.reviewsCount}
          />
          {children}
          <OffersFooterContainer />
        </Container>
      )}
      <SimilarNewbuildings hasNewbuildings={!!newbuildings.length} />
      {isPreloaderVisible && <SearchPreloader />}
    </>
  );
};

export function mapStateToProps(state: IApplicationState): TOffersProps {
  return {
    newbuildings: state.offersData.newbuildings,
    isPreloaderVisible: state.preloader.isVisible,
    newbuildingPromoSnippet: getNewbuildingPromoSnippet(state),
    isNewbuildingPromoSnippetEnabled: getIsNewbuildingPromoSnippetEnabled(state),
    isNewbuildingPromoSnippetDisplayed: state.config.isPromoSnippetDisplayed,
    seo: state.offersData?.seo,
  };
}

export const OffersContainer = connect(mapStateToProps)(Offers);
